import { FormControl, VStack, WarningIcon } from 'native-base';
import { Caption, H2 } from '~/shared/Typography';
import Button from '~/shared/Button';
import React from 'react';
import { useGeneralStyles } from '~/shared/styles';
import { useI18n } from '@springbig/shared';

type CancelSubscriptionProps = {
    onCancel: () => void;
    onProceed: () => void;
    isLoading: boolean;
    error?: string[] | string;
};

const CancelSubscription = ({ onCancel, onProceed, isLoading, error }: CancelSubscriptionProps) => {

    const gStyle = useGeneralStyles();
    const { t } = useI18n();

    return (
        <FormControl>
            <VStack textAlign={'center'} space={8}>
                <H2>{ t('subscriptions.cancellation_warning') }</H2>
                <Caption>
                    { t('subscriptions.cancellation_disclaimer') }
                </Caption>
                <FormControl.ErrorMessage
                    leftIcon={<WarningIcon size={3} />}
                >
                    { error && error[0] }
                </FormControl.ErrorMessage>
                <Button
                    bg={gStyle.button_danger_background}
                    _text={{ color: gStyle.button_danger_text }}
                    onPress={onProceed}
                >
                    { t('subscriptions.manage.cancel_subscription') }
                </Button>
                <Button
                    bg={gStyle.button_neutral_background}
                    _text={{ color: gStyle.button_neutral_text }}
                    isLoading={isLoading}
                    onPress={onCancel}
                >
                    { t('subscriptions.back_button') }
                </Button>
            </VStack>
        </FormControl>
    );
};

export default CancelSubscription;
